<template>
  <div class="container mt-4">
    <loading loader="bars" :active.sync="isLoading"></loading>
    <div class="row justify-content-around mb-3">
      <div class="col-6 col-sm-4">
        <div class="card text-center bg-transparent">
          <div class="card-body p-2 brown">
            <h5 class="card-title">網路預約</h5>
            <p class="card-text h2">{{ number.NetWorkNumber }}</p>
          </div>
        </div>
      </div>
      <div class="col-6 col-sm-4">
        <div class="card text-center bg-transparent">
          <div class="card-body p-2 brown">
            <h5 class="card-title">現場預約</h5>
            <p class="card-text h2">{{ number.LiveNumber }}</p>
          </div>
        </div>
      </div>
    </div>
    <div id="carouselExampleIndicators" class="carousel slide" data-ride="carousel">
      <ol class="carousel-indicators">
        <li data-target="#carouselExampleIndicators" v-for="(item,index) in data.img" :key="index"  :data-slide-to="index" :class="{'active':index===0}"></li>
      </ol>
      <div class="carousel-inner">
        <div class="carousel-item" v-for="(item,index) in data.img" :key="index" :class="{'active':index===0}">
          <img
            :src="item"
            class="d-block w-100 m-auto"
            alt="..."
          />
        </div>
      </div>
      <a
        class="carousel-control-prev"
        href="#carouselExampleIndicators"
        role="button"
        data-slide="prev"
      >
        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
        <span class="sr-only">Previous</span>
      </a>
      <a
        class="carousel-control-next"
        href="#carouselExampleIndicators"
        role="button"
        data-slide="next"
      >
        <span class="carousel-control-next-icon" aria-hidden="true"></span>
        <span class="sr-only">Next</span>
      </a>
    </div>
    <div class="card bg-transparent brown">
      <div class="card-body">
        <p class="card-title h1">
          {{ data.BusinessName }}
          <i class="las la-bookmark h3"></i>
        </p>
        <p
          class="card-text"
        >Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptates voluptas eum delectus eveniet consequuntur laboriosam quibusdam animi aspernatur, in accusantium sapiente repellat mollitia molestias magni tenetur non! Mollitia praesentium doloribus sed quibusdam expedita, veniam distinctio fugiat vitae earum quasi dignissimos rerum cum deserunt rem ut porro. Odio magnam magni esse velit incidunt tenetur, unde quos vero! Laudantium, asperiores porro, assumenda fugit doloribus aperiam placeat voluptate aut quod aspernatur suscipit cum corporis expedita optio quidem sunt impedit, voluptas dignissimos soluta reprehenderit ratione ducimus eaque eos. Maxime officia obcaecati quis cum amet quo repudiandae iusto ad quod. Ipsa dolorem dolore fuga totam!</p>
        <a class="btn btn-block toAppointmentBtn" href="#" @click.prevent="toReservation">我要預約</a>
        <!-- <router-link class="btn btn-block toAppointmentBtn" :to="">我要預約</router-link> -->
      </div>
    </div>
    <div class="container d-flex justify-content-center mt-4">
      <ul class="list-unstyled w-50">
        <li class="media pb-2 mb-4 pl-3">
          <div class="media-body">
            <div class="mt-0 mb-1 h5">
              <i class="las la-map-marked-alt"></i>
              {{ data.City+data.Area+data.Address }}
            </div>
          </div>
        </li>
        <li class="media pb-2 mb-4 pl-3">
          <div class="media-body">
            <div class="mt-0 mb-1 h5">
              <i class="las la-phone"></i>
              {{ data.Tel }}
            </div>
          </div>
        </li>
        <li class="media pb-2 mb-3 pl-3">
          <div class="media-body">
            <div class="mt-0 mb-1 h5">
              <i class="las la-industry"></i>
              {{ data.Industry }}
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      data: {},
      number: {},
      isLoading: false
    }
  },
  methods: {
    toReservation () {
      const vm = this
      const user = JSON.parse(sessionStorage.getItem('user'))
      if (user === null) {
        vm.$swal({
          position: 'top-end',
          background: '#F7ECEB',
          icon: 'warning',
          title: '請先登入',
          showConfirmButton: false,
          toast: true,
          timer: 3000,
          timerProgressBar: true,
          onOpen: toast => {
            toast.addEventListener('mouseenter', vm.$swal.stopTimer)
            toast.addEventListener('mouseleave', vm.$swal.resumeTimer)
          }
        })
      } else {
        this.$router.push({ name: 'Reservation', params: { BusinessId: this.data.Id } })
      }
    }
  },
  created () {
    this.isLoading = true
    const businessId = this.$route.params.BusinessId
    const vm = this
    const url = 'http://imrebooksystem.rocket-coding.com/BusinessUsers/GetBusinessListById'
    this.axios
      .get(url, { params: { id: businessId } })
      .then(function (res) {
        res.data.img = []
        var arr = [
          res.data.PictureAddress1,
          res.data.PictureAddress2,
          res.data.PictureAddress3,
          res.data.PictureAddress4,
          res.data.PictureAddress5,
          res.data.PictureAddress6,
          res.data.PictureAddress7,
          res.data.PictureAddress8
        ]
        arr.forEach(item => {
          if (item !== '') {
            res.data.img.push(item)
          }
        })
        vm.data = res.data
      })
      .catch(error => console.error(error))
    this.axios
      .get('http://imrebooksystem.rocket-coding.com/Dashboard/AllBookInfo', {
        params: { id: businessId }
      })
      .then(function (res) {
        vm.number = {
          LiveNumber: res.data.LiveNumber,
          NetWorkNumber: res.data.NetWorkNumber
        }
        vm.isLoading = false
      })
      .catch(error => console.error(error))
  }
}
</script>

<style lavg="scss" scoped>
.media {
  border-bottom: 1px solid #b8817d;
  color: #b8817d;
}
.toAppointmentBtn {
  color: #b8817d;
  border-radius: 5px;
  border: 1px solid #b8817d;
  transition: 1s;
}
.toAppointmentBtn:hover {
  transition: 1s;
  background-color: #ebd0ce;
  color: #545871;
  border: 1px solid transparent;
}
.carousel-item {
  min-height: 600px;
  max-height: 600px;
  overflow: hidden;
}
@media (max-width: 1200px) {
.carousel-item {
    min-height: 450px;
    max-height: 450px;
    overflow: hidden;
  }
}
@media (max-width: 992px) {
  .carousel-item {
    min-height: 400px;
    max-height: 400px;
    overflow: hidden;
  }
}
@media (max-width: 768px) {
  .carousel-item {
    min-height: 350px;
    max-height: 350px;
    overflow: hidden;
  }
}
@media (max-width: 576px) {
  .w-50 {
    width: 100% !important;
  }
  .carousel-item {
    min-height: 200px;
    max-height: 200px;
    overflow: hidden;
  }
}
</style>
